export default {
  publishableKey: process.env.REACT_APP_STRIPE_PK_KEY || null
}
